import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from "react-i18next";
import { SITE_URL } from 'utils/restapi';
import AuthenticationButton from 'components/elements/buttons/AuthenticationButton';

const APP_ID = '330458598700-tvc98fsf0a3np731fossp5rnd0v3ddga.apps.googleusercontent.com';
const CALLBACK_URL = `${SITE_URL}/login/google`;
const SCOPE = 'email+profile+openid';

const GoogleButton = ({ verb }) => (
  <Translation>
    {(t) => (
      <AuthenticationButton
        type='google'
        href={`https://accounts.google.com/o/oauth2/auth?client_id=${APP_ID}&response_type=code&scope=${SCOPE}&redirect_uri=${CALLBACK_URL}`}
      >
        {verb} {t("with")} <b>Google</b>
      </AuthenticationButton>
    )}
  </Translation>
);

GoogleButton.propTypes = {
  verb: PropTypes.string,
};
GoogleButton.defaultProps = {
  verb: 'Log in',
};

export default GoogleButton;
